const  sanitizerConfig= { ADD_ATTR: ['target'] };
export default sanitizerConfig;
